import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EditSettingsModel,GridComponent,IEditCell,ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { GridModule, EditService, ToolbarService, SortService } from '@syncfusion/ej2-angular-grids';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TextBox } from '@syncfusion/ej2-inputs';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-arkiwebapps',
  templateUrl: './arkiwebapps.component.html',
  styleUrls: ['./arkiwebapps.component.css'],
  providers: [EditService, ToolbarService, SortService,MessageService]

})
export class ArkiwebappsComponent implements OnInit {
  @ViewChild('grid')
  public grid: any;
  public editSettings?: EditSettingsModel;
  public toolbar?: ToolbarItems[];
  public dataList?: object[];
  public dpParams: IEditCell;
  public elemContent: HTMLElement;
  public textEditor: TextBox;
  public disableHtmlEncode;
  public valueAccessor = (field: string, data: object, column: object) => {
    var value = data[field];
    if (value != undefined) {
      return value.split('\n').join('<br>');
    } else {
      return '';
    }
  };
  constructor(
    private apiService: ApiService,
    private globalService: GlobalService,
    private messageService: MessageService,


  ) { }

  ngOnInit(): void {
    this.disableHtmlEncode = false;
    this.dpParams = {
      create: () => {
        this.elemContent = document.createElement('textarea');
        return this.elemContent;
      },
      read: () => {
        return this.textEditor.value;
      },
      destroy: () => {
        this.textEditor.destroy();
      },
      write: (args) => {
        this.textEditor = new TextBox({
          multiline: true,
          value: args.rowData[args.column.field],
          floatLabelType: 'Auto',
        });
        this.textEditor.appendTo(this.elemContent);
      },
    };
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal' };
    this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
    
    this.apiService.get('organizationchart/getapps',{}).subscribe((data)=>{
      this.dataList=[];
      let id=1;
      data.Result.forEach((d)=>{
        this.dataList.push({
          id:id,
          app_id:d.app_id,
          name:d.name,
          arkiweb_vars:d.arkiweb_vars,
          description:d.description,
          active:d.active
        });
        id++;
      });
    });
    
  }
  created(args) {
    this.grid.keyConfigs.enter = '';
  }
  save(){
    let error=false;
 
    this.dataList.forEach((d:any,ind)=>{
      if(this.dataList.filter((x:any,inx)=> x.name==d.name && inx!=ind ).length>0){
        this.addSingle('error',"Attenzione", 'Non ci possono essere due app con lo stesso nome');
        error=true;
      }
      if(this.dataList.filter((x:any)=> x.name=='' ).length>0){
        this.addSingle('error',"Attenzione", 'Non ci possono essere app senza nome');
        error=true;
      }
    });
    this.dataList.forEach((d:any,ind,obj)=>{
      obj[ind]['app_id']=d.name;
    });
    

    this.apiService.get('organizationchart/updateapps',{applist:this.dataList}).subscribe(data => {
      this.addSingle('success', 'Successo', 'Elenco app salvato');
    });

    

  }
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
}
